import { Component } from '@angular/core';

import { snFadeIn, snFadeOut } from '@lib/common/animations';
import { SnIncident } from 'libs/api/entities/src/lib/incident';
import { SnTableBaseComponent } from 'libs/core/src/lib/components/table-base.component';

@Component({
  selector: 'sn-incident-case-search-table',
  templateUrl: './incident-case-search-table.component.html',
  animations: [snFadeIn, snFadeOut],
})
export class IncidentCaseSearchTableComponent extends SnTableBaseComponent<SnIncident> {
  constructor() {
    super();
  }

  public trackBy(index: number, item: SnIncident): any {
    return item.id;
  }
}
